import { render, staticRenderFns } from "./ESkeleton.vue?vue&type=template&id=2d37e99e&scoped=true"
import script from "./ESkeleton.vue?vue&type=script&lang=js"
export * from "./ESkeleton.vue?vue&type=script&lang=js"
import style0 from "./ESkeleton.vue?vue&type=style&index=0&id=2d37e99e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d37e99e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d37e99e')) {
      api.createRecord('2d37e99e', component.options)
    } else {
      api.reload('2d37e99e', component.options)
    }
    module.hot.accept("./ESkeleton.vue?vue&type=template&id=2d37e99e&scoped=true", function () {
      api.rerender('2d37e99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ESkeleton.vue"
export default component.exports